(function($){

    $(document).ready(function(){

        // Initialise chaque formulaire présent sur la page (normalement 1, mais le
        // sélecteur chien/chat en génère 2 — un par variante — dans le même bloc).
        $('.animal-form-wrapper').each(function(){
            initWrapper($(this));
        });

        // Bascule chien/chat du formulaire famille d'accueil
        $('.famille-choix-buttons').on('click', '.famille-choix-btn', function(){
            var $btn        = $(this);
            var variantType = $btn.data('variant-type');

            $btn.siblings('.famille-choix-btn').removeClass('active');
            $btn.addClass('active');

            $('.famille-variant').removeClass('active');
            $('.famille-variant[data-variant-type="' + variantType + '"]').addClass('active');
        });

        // Continuer en tant que (utilisateur connecté)
        $('#adoption-form').on('click', '.continuer-btn', function(e){
            e.preventDefault();
            switchStep(2, $(this).closest('.animal-form-wrapper'));
        });

        // Login AJAX (click ou submit du form)
        $('#adoption-form').on('submit', '.login-form', function(e){
            e.preventDefault();
            $(this).find('.login-submit-btn').trigger('click');
        });
        $('#adoption-form').on('click', '.login-submit-btn', function(e){
            e.preventDefault();
            var $btn     = $(this);
            var $wrapper = $btn.closest('.animal-form-wrapper');
            var $loginCol = $btn.closest('.login-col');
            var login    = $loginCol.find('[name="log"]').val().trim();
            var pwd      = $loginCol.find('[name="pwd"]').val();
            var nonce    = $wrapper.find('.adoption-login-nonce').val();

            $loginCol.find('.login-error').hide().text('');

            if ( ! login || ! pwd ) {
                $loginCol.find('.login-error').text('Veuillez remplir tous les champs.').show();
                return;
            }

            $btn.attr('disabled', 'disabled').addClass('loading');
            $wrapper.find('.all-step').addClass('is-loading');

            grecaptcha.ready(function() {
                grecaptcha.execute(blockData.recaptcha_site_key, { action: 'login' }).then(function(token) {
                    $.post(blockData.ajax_url, {
                        action:          'theme_client_ajax_login',
                        nonce:           nonce,
                        log:             login,
                        pwd:             pwd,
                        recaptcha_token: token
                    }, function(res){
                        if ( res.success ) {
                            window.location.reload();
                        } else {
                            $loginCol.find('.login-error').text(res.messages).show();
                            $btn.attr('disabled', false).removeClass('loading');
                            $wrapper.find('.all-step').removeClass('is-loading');
                        }
                    }, 'json');
                });
            });
        });

        // Inscription AJAX (click ou submit du form)
        $('#adoption-form').on('submit', '.register-form', function(e){
            e.preventDefault();
            $(this).find('.register-submit-btn').trigger('click');
        });
        $('#adoption-form').on('click', '.register-submit-btn', function(e){
            e.preventDefault();
            var $btn         = $(this);
            var $wrapper     = $btn.closest('.animal-form-wrapper');
            var $registerCol = $btn.closest('.register-col');
            var nonce        = $wrapper.find('.adoption-register-nonce').val();
            var prenom       = $registerCol.find('[name="prenom"]').val().trim();
            var nom          = $registerCol.find('[name="nom"]').val().trim();
            var email        = $registerCol.find('[name="email"]').val().trim();
            var pwd          = $registerCol.find('[name="password"]').val();
            var confirm      = $registerCol.find('[name="password_confirm"]').val();

            $registerCol.find('.register-error').hide().text('');

            if ( ! prenom || ! nom || ! email || ! pwd || ! confirm ) {
                $registerCol.find('.register-error').text('Tous les champs sont requis.').show();
                return;
            }
            if ( pwd !== confirm ) {
                $registerCol.find('.register-error').text('Les mots de passe ne correspondent pas.').show();
                return;
            }

            $btn.attr('disabled', 'disabled').addClass('loading');
            $wrapper.find('.all-step').addClass('is-loading');

            grecaptcha.ready(function() {
                grecaptcha.execute(blockData.recaptcha_site_key, { action: 'register' }).then(function(token) {
                    $.post(blockData.ajax_url, {
                        action:           'theme_client_ajax_register',
                        nonce:            nonce,
                        prenom:           prenom,
                        nom:              nom,
                        email:            email,
                        password:         pwd,
                        password_confirm: confirm,
                        recaptcha_token:  token
                    }, function(res){
                        if ( res.success ) {
                            window.location.reload();
                        } else {
                            $registerCol.find('.register-error').text(res.messages).show();
                            $btn.attr('disabled', false).removeClass('loading');
                            $wrapper.find('.all-step').removeClass('is-loading');
                        }
                    }, 'json');
                });
            });
        });

        // TODO patch temporaire pour éviter des trous dans la formulaire
        $('.grid-form-wrapper').each(function() {
            var group = [];
            $(this).children().each(function() {
                if ($(this).hasClass('col-full')) {
                    if (group.length % 2 === 1) {
                        group[group.length - 1].classList.add('col-full');
                    }
                    group = [];
                } else {
                    group.push(this);
                }
            });
            if (group.length % 2 === 1) {
                group[group.length - 1].classList.add('col-full');
            }
        });

        // swtich l'étape
        $('.form-nav-wrapper').on('click','.button',function(e){
            e.preventDefault();
            if ( $(this).hasClass('login-submit-btn') || $(this).hasClass('register-submit-btn') || $(this).hasClass('continuer-btn') ) {
                return;
            }
            var button   = $(this);
            var $wrapper = button.closest('.animal-form-wrapper');

            var step = $(this).parents('.step-wrapper').data('step');
            var data;

            if($(this).hasClass('prev-button-link')){
                switchStep(step - 1, $wrapper);
                return;
            }

            data = validateAll(step, $wrapper);

            if(!data){
                return;
            }else{
                button.attr('disabled', 'disabled').addClass('loading');
                $wrapper.find('.all-step').addClass('is-loading');
            }

            var form_data = new FormData();
            if($wrapper.find(".file").length){
                var file_data = $wrapper.find(".file").prop("files");   // Getting the properties of file from file field
                for(let i=0; i<file_data.length; i++){
                    form_data.append("file["+i+"]", file_data[i]);
                }
            }

            form_data.append("action", "theme_client_ajax_switch_form_part");
            form_data.append("part", step);
            form_data.append("ajax", true);
            form_data.append("post_id", $wrapper.data('post-id'));
            form_data.append("nonce", $wrapper.find('.adoption-form-nonce').val());
            form_data.append("form_type", $wrapper.data('form-type') || 'adoption');
            for ( var key in data ) {
                form_data.append('field-'+key, data[key]);
            }

            $.ajax( {
                method : 'POST',
                url: blockData.ajax_url,
                data: form_data,
                contentType: false,
                processData: false,
                dataType: "json",
                success : function(res){
                    if(res.success == true){
                        switchStep(res.step, $wrapper);
                        $wrapper.find('.error-all').text('').hide();

                        if(res.userName !== ''){
                            logingMode(res.userName);
                        }
                        button.attr('disabled', false).removeClass('loading');
                    }else{
                        if(res.errors){
                            showError(res.errors, $wrapper);
                        }
                        $wrapper.find('.error-all').text(res.messages).css('display', 'flex');
                        $('html, body').animate({
                            scrollTop: $wrapper.find(".all-step").offset().top - 100
                        }, 1000, "linear");
                        button.attr('disabled', false).removeClass('loading');
                        $wrapper.find('.all-step').removeClass('is-loading');
                        return  false;
                    }
                },
            });
        });

        // retour aux étapes disponibles via les pastilles
        $('.steps-indicator').on('click', '.step-item.available', function(){
            switchStep($(this).data('step'), $(this).closest('.animal-form-wrapper'));
        });

        // ajax pour la liste d'appel checklist
        $('body').on('submit','.checklist-form', function(e){
            e.preventDefault();
            var form           = $(this);
            var button         = form.find('.button');
            var $checklistWrap = form.closest('.checklist-wrapper');

            button.attr('disabled', 'disabled').addClass('loading');

            var data = {};

            form.find('.field').each(function (i, input) {
                if($(this).attr('type') == 'checkbox'){
                    var val = '';
                    // Scopé au form courant (voir même correctif dans validateAll).
                    form.find("input[name='" + $(this).attr('name') + "']:checked").each(function () {
                        val += $(this).val() + ', ';
                    });

                    val = val.replace(/,\s*$/, ""); // retire dernière virgule et espace

                    data[$(this).attr('name')] = val;
                }
            });

            var data = {
                ajax: true,
                action: 'theme_client_push_call_checklist',
                nonce:  $checklistWrap.find('.adoption-checklist-nonce').val(),
                data: data,
                userID: $checklistWrap.data('user')
            }

            $.post( blockData.ajax_url, data, function(res){
                if(res.success == true){
                    $('.error-all').text('').hide();
                    button.attr('disabled', false);
                    button.removeClass('loading');
                }else{
                    $('.error-all').text(res.messages).css('display', 'flex');
                    button.attr('disabled', false);
                }
            },"JSON");
        });
    });

    // Initialise le step de départ (sans animation) pour un formulaire donné
    function initWrapper($wrapper){
        var startStep = parseInt($wrapper.data('start-step') || 1);
        $wrapper.data('max-step', startStep);

        // pas en mode lecture seule
        if ( startStep > 1 && $wrapper.data('edit') !== 'no-edit' ) {
            $wrapper.find('.step-wrapper').removeClass('active');
            $wrapper.find('.step-wrapper[data-step="' + startStep + '"]').addClass('active');
            $wrapper.find('.steps-indicator .step-item').each(function(){
                var itemStep = parseInt($(this).data('step'));
                $(this).removeClass('active available');
                if ( itemStep === startStep ) {
                    $(this).addClass('active');
                } else if ( itemStep < startStep ) {
                    $(this).addClass('available');
                }
            });
        }
    }

    function switchStep(step, $wrapper){
        $wrapper = ($wrapper && $wrapper.length) ? $wrapper : $('.animal-form-wrapper').first();

        if(step == 6){ // step 6 = la fin
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'form_submission',
                'event_category': 'form',
                'event_label': 'Formulaire ' + $wrapper.find('h1').text() + ' complété'
            });
        }
        var step     = parseInt(step);
        var maxStep  = Math.max(parseInt($wrapper.data('max-step') || 1), step);
        $wrapper.data('max-step', maxStep);
        $wrapper.find('.all-step').addClass('is-loading');
        $('html').animate({
            scrollTop: $wrapper.find(".all-step").offset().top - 100
        }, 1000, "linear",function(){
            $wrapper.find('.step-wrapper').removeClass('active');
            $wrapper.find('.step-wrapper[data-step="'+step+'"]').addClass('active');

            $wrapper.find('.steps-indicator .step-item').each(function(){
                var itemStep = parseInt($(this).data('step'));
                $(this).removeClass('active available');
                if(itemStep === step){
                    $(this).addClass('active');
                } else if(itemStep <= maxStep){
                    $(this).addClass('available');
                }
            });

            $wrapper.find('.all-step').removeClass('is-loading');
        });
    }

    function showError(errors, $wrapper){
        $.each(errors, function(i,error){
            $wrapper.find('[name="'+i+'"').siblings('.error').text(error);
        });
    }


    // Fonction requise pour valider les courriels. Ne pas la prendre si elle est déjà dans le projet.
    function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // TODO: ne pas accepter un IP
        return re.test(email);
    }

    // valide les champs de formulaire de l'étape
    function validateAll(step, $wrapper){
        $wrapper = ($wrapper && $wrapper.length) ? $wrapper : $('.animal-form-wrapper').first();

        var parentStep = $wrapper.find('.step-wrapper[data-step="'+step+'"]');
        var valid = true;
        var form = parentStep;
        var data = {};
        var require_one = false;
        var require_one_valid = false;
        var error_text = 'Un ou plusieurs champs contiennent une erreur. Veuillez vérifier et essayer de nouveau.';

        console.group('validateAll — step ' + step);
        console.log('Fields trouvés:', parentStep.find('.field').length);

        //submit.width(submit.width()).height(submit.height()).attr('disabled', 'disabled').addClass('loading').html(loader);
        parentStep.find('.invalid').removeClass('invalid');

        parentStep.find('.field').each(function (i, input) {

            if ($(this).hasClass('require_one')) {
                require_one = true;

                if ($(this).val() != '') {
                    require_one_valid = true;
                }
            }

            if ($(this).attr('type') == 'checkbox' || $(this).attr('type') == 'radio') {
                var val = '';
                // Scopé à l'étape courante (form.find, pas $(document).find) : le
                // sélecteur global matcherait aussi le même champ (même "name")
                // d'une autre variante (chien/chat) affichée en lecture seule sur
                // la même page, faussant la valeur envoyée au serveur.
                form.find("input[name='" + $(this).attr('name') + "']:checked").each(function () {
                    val += $(this).val() + ', ';
                });

                val = val.replace(/,\s*$/, ""); // retire dernière virgule et espace

                data[$(this).attr('name')] = val;

            } else {
                data[$(this).attr('name')] = $(this).val();
            }

            if ($(this).attr('required')) {
                if ($(this).val() == '') {
                    console.warn('FAIL (vide) — name:', $(this).attr('name'), '| type:', $(this).attr('type'), '| val:', $(this).val());
                    valid = false;
                    $(this).addClass('invalid').focus(function () {
                        $(this).removeClass('invalid');
                    });
                    $(this).parents('.form-element-wrapper').find('p.error').text('Ce champs est requis');
                }
            }

            if ($(this).attr('type') == 'checkbox' || $(this).attr('type') == 'radio') {
                if ($(this).attr('required') && !form.find("input[name='" + $(this).attr('name') + "']:checked").length) {
                    console.warn('FAIL (checkbox/radio non coché) — name:', $(this).attr('name'));
                    valid = false;
                    $(this).parents('.form-element-wrapper').find('p.error').text('Ce champs est requis');
                }else{
                    $(this).parents('.form-element-wrapper').find('p.error').text('');
                }

                if ($(this).data('requiredif')) {
                    let input_value = form.find('[name="' + $(this).data('requiredif') + '"]').val();

                    if (input_value != '' && !$(this).prop('checked')) {
                        valid = false;
                        if ($(this).parents('.checkbox-label').length) {
                            $(this).parents('.checkbox-label').addClass('invalid');

                            $(this).focus(function () {
                                $(this).parents('.checkbox-label').removeClass('invalid');
                            });

                        } else {
                            $(this).parent('label').addClass('invalid');

                            $(this).focus(function () {
                                $(this).parent('label').removeClass('invalid');
                            });
                        }
                    }
                }
            }

            if ($(this).attr('type') == 'email' && $(this).val() != '') {
                if (!validateEmail($(this).val())) {
                    valid = false;
                    $(this).parents('.form-element-wrapper').find('p.error').text("Le courriel n'est pas valide");
                }else{
                    $(this).parents('.form-element-wrapper').find('p.error').text("");
                }

            }

            if($(this).attr('type') == 'file'){
                if($(this)[0].files.length){
                    for(let i = 0; i < $(this)[0].files.length; i++){
                        if($(this)[0].files[i].size > 5000000){
                            valid = false;
                            error_text = "L'image est trop grosse. (5mo max)";
                        }
                        var extension = $(this)[0].files[i].name.substr( ($(this)[0].files[i].name.lastIndexOf('.') +1) );
                        if(extension == "png" || extension == "jpeg" || extension == "jpg"){

                        }else{
                            valid = false;
                            error_text = "L'image doit être un jpeg, jpg ou png";
                        }
                    }
                }
            }
        })

        if (require_one && !require_one_valid) {
            console.warn('FAIL (require_one — aucun champ rempli)');
            valid = false;
            error_text = 'Vous devez remplir au moins un des champs.';

            form.find('.require_one').addClass('invalid').focus(function () {
                $(this).removeClass('invalid');
            });
        }

        console.log('Résultat valid:', valid);
        console.groupEnd();

        if(valid){
            $wrapper.find('.error-all').text(error_text).hide();
            $wrapper.find('.form-element-wrapper p.error').text('');
            return data;
        }else{
            $wrapper.find('.error-all').text(error_text).css('display', 'flex');
            $('html, body').animate({
                scrollTop: $wrapper.find(".all-step").offset().top - 100
            }, 1000, "linear");
            return  false;

        }
    }

    function logingMode(name){
        $('.loading-system-wrapper').empty();
    }


})(jQuery);
